/* This component CREATES a Pilot - Cohort - Source table for the pilotcohortsource collection in MongoDB. */

import React, { useEffect, useState }           from 'react'
import axios                                    from 'axios'
import Box                                      from "@material-ui/core/Box"
import {
   Grid,
   Typography }                                 from '@material-ui/core'
import { CLIENT_PUBLIC_TOKEN }                  from '../config'
import { node_server }                          from '../Helpers'
import PropTypes                                from 'prop-types'

const PilotCohortSourceReadComponent = ( { id } ) => {

   const [ displayTable,      setDisplayTable         ]  =  useState([])

   useEffect( () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      if ( id && id.length > 0 ) {
         axios.get(node_server + `pilotCohortSourceTable/${id}`)
            .then( res => res.data )
            .then( data => {
               const t = data.table
               setDisplayTable(
                  <Grid>
                     <Grid container direction='row'>
                        <Grid item xs={3} >
                           <Typography align='left' >
                              Pilot
                           </Typography>
                        </Grid>
                        <Grid item xs={2} style={{paddingLeft: '2rem'}} >
                           <Typography align='left' >
                              Cohort
                           </Typography>
                        </Grid>
                        <Grid item xs={6} >
                           <Typography align='left' >
                              Source Information
                           </Typography>
                        </Grid>
                     </Grid>
                     {t.tableRow.length > 0
                        ?
                           t.tableRow.map( r => {
                              return(
                              <Grid container direction='row' key={r._id} style={{marginTop: '0.5rem'}} >
                                 <Grid item xs={3} key={r._id + 1} >
                                    <Typography align='left' >
                                       { r.pilotName }
                                    </Typography>
                                 </Grid>
                                 <Grid item xs={2} key={r._id + 2} style={{paddingLeft: '2rem'}} >
                                    <Typography align='left' >
                                       { r.cohort }
                                    </Typography>
                                 </Grid>
                                 <Grid item xs={6} key={r._id + 3} >
                                    <Typography align='left' >
                                       { r.source }
                                    </Typography>
                                 </Grid>
                              </Grid>
                              )
                           } )
                        :
                           null
                     }
                  </Grid>
               )
            } )
      }
   }, [])



   return (
      <Box style={{marginTop: '2rem', marginBottom: '2rem'}} >
         { displayTable }
      </Box>
   )
}

PilotCohortSourceReadComponent.propTypes = {
  id:                                           PropTypes.string
}

export default PilotCohortSourceReadComponent
